import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';   // <-- added useNavigate
import { Container, Row, Col } from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import { API_URL } from '../config';
import Loading from './component/Loading';
import { Carousel } from 'react-bootstrap';
import { Button } from 'react-bootstrap';   // <-- make sure Button is imported

const nl2br = (text = '') =>
  text.split('\n').map((line, i) => (
    <span key={i}>
      {line}
      <br />
    </span>
  ));

const ProductViewOnly = () => {
  const { productId } = useParams();
  const navigate = useNavigate();   // <-- navigation hook

  const [product, setProduct] = useState({
    product_id: null,
    product_name: '',
    description: '',
    price: '',
    discounted_price: '',
    media_urls: [],
    images: [],
    custom_fields: [],
    customFields: [],
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchProductDetails = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_URL}/products/${productId}`);
        const data = await response.json();

        if (data.success && data.product) {
          const images = (data.product.media_urls || []).map((url) => ({
            original: url,
            thumbnail: url,
          }));

          setProduct({
            ...data.product,
            images,
            customFields: data.product.custom_fields || [],
          });
        }
      } catch (err) {
        console.error('Failed to fetch product details:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProductDetails();
  }, [productId]);

  const hasDiscount =
    product.discounted_price &&
    !isNaN(parseFloat(product.discounted_price)) &&
    !isNaN(parseFloat(product.price)) &&
    parseFloat(product.discounted_price) < parseFloat(product.price);

  return (
    <div className="margin-top product-detail-main">
      {loading ? <Loading text="" /> : ''}
      <Container fluid className="">
        <div className="breadcrumbs desktop-view">
          <div className="container-fluid">
            <ul>
              <li><a href="/home">Home</a></li>
              <li>Products</li>
            </ul>
          </div>
        </div>

        <Row>
          {/* Desktop gallery */}
          <Col md={5} className="desktop-view">
            {product.images && product.images.length > 0 && (
              <ImageGallery
                items={product.images.map((img) => ({
                  original: img.original,
                  thumbnail: img.thumbnail,
                }))}
                thumbnailPosition="left"
              />
            )}
          </Col>

          {/* Mobile slider */}
          <Col md={12} className="mobile-view p-0 product-detail-wrap">
            <div className="product-img-wrap">
              {product.images && product.images.length > 0 ? (
                <Carousel>
                  {product.images.map((image, index) => (
                    <Carousel.Item key={index}>
                      <img
                        className="d-block w-100"
                        src={image.original}
                        alt={`Slide ${index}`}
                      />
                    </Carousel.Item>
                  ))}
                </Carousel>
              ) : (
                <p>No images available</p>
              )}
            </div>
          </Col>

          {/* Right column: title, price, description, custom fields */}
          <Col md={7} xs={12} className="product-disc-wrap">
            <h2>{product.product_name}</h2>

            {/* Price */}
            {(product.price || product.discounted_price) && (
              <>
                {hasDiscount ? (
                  <div className="price-detail">
                    <span className="product-discountedPrice">
                      ${parseFloat(product.discounted_price).toFixed(2)}
                    </span>
                    <span
                      className="product-strike"
                      style={{ textDecoration: 'line-through' }}
                    >
                      ${parseFloat(product.price).toFixed(2)}
                    </span>
                    <span className="product-discountPercentage">
                      (Save{' '}
                      {(
                        (1 -
                          parseFloat(product.discounted_price) /
                            parseFloat(product.price)) *
                        100
                      ).toFixed(0)}
                      %)
                    </span>
                  </div>
                ) : product.price ? (
                  <div className="price-detail">
                    <span className="product-discountedPrice">
                      ${parseFloat(product.price).toFixed(2)}
                    </span>
                  </div>
                ) : null}
              </>
            )}

            <hr />

            {/* Description */}
            <div className="disc-detail">
              <h4>Product Description</h4>
              <div>{nl2br(product.description || '')}</div>
            </div>

            <hr />

            {/* Custom fields */}
            <div className="product-description">
              {product.customFields?.map((field) => {
                const validValues = (field.values || []).filter(
                  (v) => v !== null && v !== undefined && v !== ''
                );
                if (validValues.length === 0) return null;

                return (
                  <React.Fragment key={field.custom_field_id}>
                    <h6>{field.field_name}</h6>
                    {field.field_type === 'choice' ? (
                      <ul>
                        {validValues.map((v, i) => (
                          <li key={i}>{v}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>{validValues.join(', ')}</p>
                    )}
                  </React.Fragment>
                );
              })}
            </div>

            {/* Contact button */}
            <div className="btn-wrap mt-3">
              <Button
                variant="primary"
                onClick={() => navigate('/contact')}  // <-- redirects
              >
                Contact for More Info
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProductViewOnly;
